import { PickADateComponent } from './../../../pick-a-date/pick-a-date.component';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Sector } from '../../../../models/booking.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ErrorService } from '../../../../services/error.service';
import { TravelService, GetSectorAvailabilityOptions } from '../../../../services/travel.service';
import { BookingService, SectorOptions } from '../../../../services/booking.service';
import { GxUtilsService } from '../../../../services/gx-utils.service';
import { LocalStorageService, AvailabilityExtras } from '../../../../services/local-storage.service';
import { Availability } from '../../../../models/availability.model';
import { ITINERARY_CONTEXT } from '../../../../models/enums/context.enum';
import { ProductTypeUrl } from '../../../../models/enums/ProductTypeUrl.enum';
import { Router } from '@angular/router';
import { RunningDogModalComponent } from '../../../running-dog-modal/running-dog-modal.component';
import { ActionUpdaterService, ApiError } from '../../../../services/action-updater.service';

@Component({
    selector: 'gaweb-change-sector-date',
    templateUrl: './change-sector-date.component.html'
})
export class ChangeSectorDateComponent implements OnInit {
    @ViewChild(PickADateComponent) pickADateComponent: PickADateComponent;
    @ViewChild(RunningDogModalComponent) runningDogModalComponent;
    processing: boolean;
    departureDate: string;
    private _sector: Sector;
    @Input() set sector(s: Sector) {
        this._sector = s;
    }
    get sector() {
        return this._sector;
    }
    minimumDate: Date = new Date();
    @Input() bookingGuid: string;
    changeDateFormSubmitted: boolean;
    operatingDays: Array<number>;
    minDate = new Date();
    ProductTypeUrl = ProductTypeUrl;
    showJustSectors: boolean;
    productTypeName: string;
    isMyGreyhound: boolean;
    private _context: ITINERARY_CONTEXT;
    @Input()
    set context(c: ITINERARY_CONTEXT) {
        this._context = c;
        this.isMyGreyhound = c === ITINERARY_CONTEXT.MY_GREYHOUND;
    }
    get context(): ITINERARY_CONTEXT {
        return this._context;
    }
    private _productType: ProductTypeUrl;
    @Input()
    set productType(value: number) {
        this._productType = value;
        this.showJustSectors = this._productType === ProductTypeUrl.expressBooking;
        this.productTypeName = ProductTypeUrl[this._productType];
    }
    get productType(): number {
        return this._productType;
    }
    constructor(private fb: FormBuilder,
        private errorService: ErrorService,
        private travelService: TravelService,
        private bookingsService: BookingService,
        private gxUtils: GxUtilsService,
        private router: Router,
        private actionUpdaterService: ActionUpdaterService,
        private localStorageService: LocalStorageService) {
    }

    ngOnInit() {
    }

    getChangeDateAvailability = () => {
        this.getAvailability(null, null, this.departureDate);
    };


    private getAvailability = (isDateForward, currentAvailabilityData, newAvailabilityDate) => {
        this.runningDogModalComponent.showModal();
        this.changeDateFormSubmitted = true;
        this.processing = true;
        const getSectorAvailabilityOptions =
            new GetSectorAvailabilityOptions(this.bookingGuid, this.sector.SectorNumber);

        const newDateProperty = isDateForward ? 'NextTravelDate' : 'PreviousTravelDate',
            isNavigationOneDayForwardOrBack = !!isDateForward && !!currentAvailabilityData && !newAvailabilityDate,
            isNavigationForwardOrBack = !isDateForward && !!newAvailabilityDate;

        if (isNavigationOneDayForwardOrBack) {
            getSectorAvailabilityOptions.travelDate = this.gxUtils
                .fromServerDate(currentAvailabilityData[newDateProperty]);
        } else if (isNavigationForwardOrBack) {
            getSectorAvailabilityOptions.travelDate = this.gxUtils.fromServerDate(newAvailabilityDate);
        } else {
            getSectorAvailabilityOptions.travelDate = this.sector.departureDate;
        }

        this.travelService.getSectorAvailability(getSectorAvailabilityOptions).subscribe((availability: Availability[]) => {
            this.processing = false;
            this.localStorageService.saveTravelAvailability(availability);
            this.localStorageService.currentAvailability = availability;
            const availabilityExtras = new AvailabilityExtras();
            availabilityExtras.bookingGuid = this.bookingGuid;
            availabilityExtras.context = this.context;
            availabilityExtras.sector = this.sector.SectorNumber;
            this.localStorageService.saveAvailabilityExtras(availabilityExtras);
            this.runningDogModalComponent.hideModal();
            this.router.navigate(
                [`/book-a-ticket/express-booking/availability`],
                {
                    queryParams: {
                        context: ITINERARY_CONTEXT.MY_GREYHOUND
                    }
                }
            );
        }, this.onError);
    };

    onError = (error: ApiError) => {
        this.runningDogModalComponent.hideModal();
        this.localStorageService.saveError(error);
        this.actionUpdaterService.announceError(error);
    }
    private availabilitySelected = (travelAvailability, routeOption) => {
        const sectorOptions = new SectorOptions(this.bookingGuid,
            travelAvailability.TravelGUID,
            routeOption.Fares[0].FareGUID,
            this.sector.SectorNumber);
        return this.bookingsService.updateSector(sectorOptions);
    }

    valueChange(date) {
        this.departureDate = date;
    }

    showCalendar($event) {
        this.pickADateComponent.showCalendar($event);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/itinerary/travel-dates/change-sector-date/change-sector-date.component.ts